import React, {
  useEffect,
  useState,
} from "react";

import {
  Swiper,
  SwiperSlide,
} from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";

import {
  Navigation,
  Autoplay,
} from "swiper/modules";

import school from "../assets/school.jpg";

const Hero = () => {
  const [slides, setSlides] =
    useState([]);

  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/slider"
    )
      .then((res) => res.json())
      .then((data) =>
        setSlides(
          Array.isArray(data)
            ? data
            : []
        )
      )
      .catch((err) =>
        console.log(
          "Slider Error:",
          err
        )
      );
  }, []);

  return (
    <div className="w-full relative">

      <Swiper
        modules={[
          Navigation,
          Autoplay,
        ]}
        navigation={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        speed={1800}
        loop={true}
        className="w-full h-[65vh] md:h-[80vh]"
      >

        {/* STATIC SLIDE */}
        <SwiperSlide>

          <div
            className="relative w-full h-[65vh] md:h-[80vh] bg-cover bg-center"
            style={{
              backgroundImage: `url(${school})`,
            }}
          >

            {/* OVERLAY */}
            <div className="absolute inset-0 bg-black/50"></div>

            {/* CONTENT */}
            <div className="absolute inset-0 flex items-center justify-center px-4">

              <div className="text-center text-white max-w-4xl">

                <h1 className="text-3xl sm:text-4xl md:text-6xl font-extrabold mb-4 leading-tight">

                  ST. JOSEPH'S SCHOOL
  
                </h1>

                <h2 className="text-lg sm:text-2xl font-medium mb-4">
               Maharajganj, UP - 273303
                </h2>

              </div>
            </div>
          </div>
        </SwiperSlide>

        {/* DYNAMIC SLIDES */}
        {slides.map((slide) => (
          <SwiperSlide
            key={slide.id}
          >

            <div
              className="relative w-full h-[65vh] md:h-[80vh] bg-cover bg-center"
              style={{
                backgroundImage: `url(https://stjosephweb.ilakshyaerp.in/uploads/slider/${slide.image})`,
              }}
            >

              {/* OVERLAY */}
              <div className="absolute inset-0 bg-black/40"></div>

            </div>

          </SwiperSlide>
        ))}

      </Swiper>
    </div>
  );
};

export default Hero;